import React, { useState, useContext, useEffect } from 'react';
import { addcontext } from '../../ContextShare/ContextShare';
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify';
import { AddReservation, GetReservation } from '../../Services/allApi';

function AddNewReservation({isEdited,setIsEdited}) {
    const [roleData, setRoleData] = useState();
    const [roleMal,setRoleMal]=useState()

    const [existingRole, setExistingRole] = useState([
        // { id: 1, name: 'Role 1' },
        // { id: 2, name: 'Role 2' },
        // { id: 3, name: 'Role 3' },
    
    ]);

    const [isConsAdded,setisConsAdded]=useState(true)

    const handleSave = async () => {
        if(roleData&&roleMal){
         const token=sessionStorage.getItem('access_token')
         const reqHeader = {
          "Content-Type": "application/json",
          "Authorization": `${token}`
      };
        const res=await AddReservation({reserved_for:roleData,mal_reserved_for:roleMal},reqHeader)
        console.log(res);
       if(res.status==200){
        toast.success("Role added successfully")
        setRoleData('')
        setRoleMal('')
        setisConsAdded(!isConsAdded)
        setIsEdited(isEdited+10)
       }
       else{
        const messageData = res?.response?.data?.message;
        // Check if messageData is an object
        const errorMessage = typeof messageData === 'object' && messageData !== null
            ? messageData[Object.keys(messageData)?.[0]]?.[0] // Get the first message from the object
            : messageData; // If it's a string, use it directly
        toast.error(errorMessage ?? "There was a problem adding reservation");
       }
    }else{
        toast.warning("Please fille both fileds")
    }
    };

    const existingReservation=async()=>{
        const result=await GetReservation()
        console.log(result);
        const newRoleList=result.data?.data?.map((item)=>(
             { id: item.id, name:item.reserved_for  }
        ))
        setExistingRole(newRoleList)
    }
    useEffect(()=>{
        existingReservation()
    },[isConsAdded])

    return (
        <>
            <div className='w-full flex items-center flex-col'>
                <h3 className='text-blue-700 text-xl font-bold mt-5 mb-5 text-center'>Enter Reservation Details</h3>

                <div className='flex flex-row justify-center flex-wrap mb-5 ms-5 me-5 gap-5 w-full '>

                    <div className='w-3/12 flex flex-col'>
                        <label htmlFor="eventname">Enter New Reservation</label>
                        <input
                            id='eventname'
                            // placeholder='Add new event'
                            value={roleData}
                            onChange={(e) => setRoleData(e.target.value)}
                            type="text"
                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                        />
                    </div>

                    <div className='w-3/12 flex flex-col'>
                        <label htmlFor="eventnam">Enter New Reservation in Malayalam</label>
                        <input
                            id='eventnam'
                            // placeholder='Add new event'
                            value={roleMal}
                            onChange={(e) => setRoleMal(e.target.value)}
                            type="text"
                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                        />
                    </div>


                </div>

                <br />
                <div className='w-2/12'>
                    <button className='w-full py-2 bg-primary text-white rounded-full' onClick={handleSave}>Save</button>
                </div>

                <div className='w-11/12 mt-10 border bg-success '>
                    <h4 className='text-blue-700 text-lg font-bold mb-5 mt-5 text-center'>Existing Reservations</h4>
                    <div className='flex flex-col items-center mb-5'>
                        {existingRole?.map(item => (
                            <div key={item.id} className='bg-white shadow-md rounded-lg px-4 py-2 mb-2 w-6/12 border border-gray-200'>
                                <div className='text-lg font-semibold'>{item.name}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                // pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            /> */}
        </>
    );
}

export default AddNewReservation;
